import type { TOnAction } from 'bz-draft/modules/stores/form-store';

import withDisplayName from 'bz-utilities/hoc/display-name';

import { observer } from 'mobx-react';

import type React from 'react';

import type { Psfs } from 'tm3-core/api.dtos';

import './style.css';
import DraftEnityControlBody from './body';

export interface IProps {
  aiFilledFields: Set<string>;
  attributes?: any;
  cache: any;
  children?: any[];
  control?: React.FunctionComponent<any> | React.ComponentClass<any>;
  defaults?: any;
  draggable?: boolean;
  errored: boolean;
  field: string;
  inline?: boolean;
  lookups: any;
  lists: any;
  psfs: Psfs[];
  readOnly?: boolean;
  searches: any;
  valueOther: any;
  validationResult: any;
  value: any;
  warning: boolean;
  formId?: string;

  onAction: TOnAction;
  onChange: (field: any, value: any, options: any, aiFilled?: boolean) => void;
  onChangeOther: (value: any, options: any, aiFilled?: boolean) => void;
  onConnect?: boolean;
  onDragStart?: React.DragEventHandler<HTMLSpanElement>;
  onMouseDown?: () => void;
  onReferralPortal?: boolean;
  onSelect?: (key?: any, blockKey?: any) => void;
}

export const defaultProps: Partial<IProps> = {
  defaults: {},
  inline: true,
  onSelect: () => {},
  onDragStart: () => {},
  onMouseDown: () => {}
};

const Control = observer(
  withDisplayName(
    Object.assign(
      (props: IProps) => {
        const { attributes, children, control, onConnect, onReferralPortal } = props;

        if (
          (onReferralPortal && attributes.hideonreferralportal) ||
          (onConnect && (attributes.hideFromForms || attributes.hideonpatientportal))
        ) {
          return null;
        }

        const renderControl = control?.default ?? control; //some controls not being imported correctly - to be cleaned up in future
        if (!renderControl) {
          return <span>Control Not Found</span>;
        }

        return <DraftEnityControlBody {...props} children={children} />;
      },
      { defaultProps }
    ),
    'DraftEnityControlWrapper'
  )
);

export default Control;
